export const ADD_COMMENT_REQUEST = 'ADD_COMMENT_REQUEST';
export const EDIT_COMMENT_REQUEST = 'EDIT_COMMENT_REQUEST';
export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST';
export const RESTORE_COMMENT_REQUEST = 'RESTORE_COMMENT_REQUEST';

export const addComment = (type, id, data, callback) => ({
    type: ADD_COMMENT_REQUEST,
    payload: { type, id, data, callback }
});

export const editComment = (type, id, commentId, data, callback) => ({
    type: EDIT_COMMENT_REQUEST,
    payload: { type, id, commentId, data, callback }
});

export const deleteComment = (type, id, commentId, callback) => ({
    type: DELETE_COMMENT_REQUEST,
    payload: { type, id, commentId, callback }
});

export const restoreComment = (type, id, commentId, callback) => ({
    type: RESTORE_COMMENT_REQUEST,
    payload: { type, id, commentId, callback }
});
